/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".side-bar[_ngcontent-%COMP%]{position:fixed;right:-260px;top:0;bottom:0;width:260px;z-index:1040;box-shadow:0 0 22px 11px #0000006b}.side-bar-dim[_ngcontent-%COMP%]{background-color:#000000b8;position:fixed;left:0;right:0;top:0;bottom:0;z-index:10;opacity:0}.navbar-brand[_ngcontent-%COMP%]{margin-top:-15px;margin-bottom:-15px;line-height:3rem;font-size:1.5rem}a.navbar-brand[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{max-height:50px;height:50px}"];
export { styles as styles };
